import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

$(function () {
    // Animation
    let defaultEase = "circ.inOut";

    function loadAnimation() {
        setTimeout(() => {
            if ($(".contact").length) {
                // gsap.to(".contact .contact-map", {
                //     opacity: 1,
                //     delay: 0.6,
                //     duration: 0.8,
                //     ease: defaultEase
                // })

                // gsap.to(".contact .contact-container", {
                //     y: 0,
                //     delay: 0.7,
                //     duration: 0.8,
                //     ease: defaultEase
                // })

                // gsap.to(".contact .contact-container .contact-info .info-item", {
                //     y: 0,
                //     opacity: 1,
                //     stagger: 0.1,
                //     delay: 1.3,
                //     duration: 0.8,
                //     ease: defaultEase
                // })

                // gsap.to(".contact .contact-container .contact-form form", {
                //     y: 0,
                //     opacity: 1,
                //     stagger: 0.1,
                //     delay: 1.3,
                //     duration: 0.8,
                //     ease: defaultEase,
                // })

                // gsap.to(".contact .contact-container .contact-form .form-info", {
                //     y: 0,
                //     opacity: 1,
                //     stagger: 0.1,
                //     delay: 1.3,
                //     duration: 0.8,
                //     ease: defaultEase,
                // })

                gsap.to(".contact .contact-map", {
                    opacity: 1,
                    delay: 0.6,
                    duration: 0.8,
                    ease: defaultEase
                })

                gsap.to(".contact .contact-container .contact-info .info-item", {
                    y: 0,
                    opacity: 1,
                    stagger: 0.1,
                    delay: 1.3,
                    duration: 0.8,
                    ease: defaultEase
                })

                gsap.to(".contact .contact-container .contact-form", {
                    y: 0,
                    opacity: 1,
                    delay: 1.3,
                    duration: 0.8,
                    ease: defaultEase,
                })

                gsap.to(".contact > .contact-info", {
                    y: 0,
                    opacity: 1,
                    delay: 1.3,
                    duration: 0.8,
                    ease: defaultEase,
                })
            }
        }, 500);
    }

    if ($(window).width() >= 1200) {
        loadAnimation();
    }

    $(window).resize(function () {
        if ($(window).width() >= 1200) {
            loadAnimation();
        }
    });

    // Marquee
    if (document.querySelector(".contact > .contact-info")) {
        let timeline = gsap.timeline();
        let sentenceWidth = document.querySelector('.contact > .contact-info .item-marquee .marquee-text').offsetWidth;
        let contactInfoOffset = $('.contact > .contact-info').offset();

        // Init timeline and register events.
        function init() {
            setTimeline();
            window.addEventListener('resize', handleResize);
            timeline.pause()

            $(window).scroll(function () {
                if (($(this).scrollTop() + window.innerHeight) > contactInfoOffset.top) {
                    timeline.play()
                } else {
                    timeline.pause()
                }
            });
        }

        // Add marquee animations to timeline.
        function setTimeline() {
            timeline
                .add(createMarquee(document.querySelector('.contact > .contact-info .item-marquee'), 'right'), 0)
        }

        // Create single marquee animation.
        function createMarquee(element, direction) {
            const distance = sentenceWidth * 2;
            return gsap.timeline()
                .to(element, {
                    duration: 20,
                    ease: 'none',
                    x: direction === 'left' ? distance : -distance,
                    onComplete() {
                        timeline.play(0);
                    },
                    onReverseComplete() {
                        timeline.reverse(0);
                    },
                },
                );
        }

        // Reset timeline on resize.
        function handleResize() {
            sentenceWidth = document.querySelector('.contact > .contact-info .item-marquee .marquee-text').clientWidth;
            timeline.seek(0);
            timeline.clear();
            setTimeline();
        }

        init();
    }

    // Item Hospital
    $(".contact .contact-container .contact-info .info-item .item-link").click(function () {
        let itemId = $(this).data("id");

        $(".hospital-modal").each(function () {
            let modolId = $(this).data("id");

            if (itemId == modolId) {
                $(this).addClass("active")
            } else {
                $(this).removeClass("active")
            }
        });
    });

    $(".hospital-modal .modal-close").click(function () {
        $(".hospital-modal").removeClass("active")
    });
})